import React from 'react';

const OpCommandCenter = () => {
  const commandCards = [
    {
      icon: 'user-plus',
      title: 'Add Administrator',
      description: 'Add your own account as server administrator',
      colorClass: 'text-accent-green',
    },
    {
      icon: 'database',
      title: 'Extract Data',
      description: 'Extract player data, configs, and databases',
      colorClass: 'text-accent-blue',
    },
    {
      icon: 'door-open',
      title: 'Install Backdoor',
      description: 'Install persistent access to the server',
      colorClass: 'text-accent-red',
    },
  ];

  return (
    <div className="mb-8 bg-dark-600 rounded-2xl p-6 gradient-bg-green">
      <div className="flex justify-between items-center mb-5">
        <h3 className="font-bold text-lg flex items-center">
          <i className="fas fa-terminal mr-2 text-accent-green"></i> 
          Operator Command Center
        </h3>
        <div className="text-sm text-gray-400 flex items-center">
          <i className="fas fa-lock mr-1"></i> Locked - OP Required
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5 opacity-50">
        {commandCards.map((card, index) => (
          <div key={index} className="bg-dark-500 rounded-xl p-4 cursor-not-allowed">
            <div className="flex items-center mb-2">
              <i className={`fas fa-${card.icon} ${card.colorClass} mr-2`}></i>
              <h4 className="text-sm font-semibold">{card.title}</h4>
            </div>
            <p className="text-xs text-gray-400 mb-3">{card.description}</p>
            <button disabled className="w-full py-2 bg-dark-400 text-gray-500 rounded-lg text-xs">Execute</button>
          </div>
        ))}
      </div>
      
      <div className="flex justify-center">
        <button className="px-6 py-2 bg-dark-400 text-gray-500 rounded-lg text-sm cursor-not-allowed">
          <i className="fas fa-lock mr-2"></i> OP Access Required
        </button>
      </div>
    </div>
  );
};

export default OpCommandCenter;
